import { hubService, workerService } from '@/services';
import { hubSelectorGetterType } from '@/vuex-store/hub-selector/getters';
import { userGetterType } from '@/vuex-store/user/getters';
export default {
    async isHubEmployeeNumberExist(context, { hubEmployeeNumber }) {
        const response = await workerService.isHubEmployeeNumberExist({
            hubEmployeeNumber,
        });
        return response.data;
    },
    async isPhoneExist(context, { phone }) {
        const response = await workerService.isPhoneExist({
            phone,
        });
        return response.data;
    },
    /**
     * 라이더 등록
     */
    async postWorker({ rootGetters }, payload) {
        const distributorId = rootGetters[userGetterType.distributorId];
        const hubId = rootGetters[hubSelectorGetterType.getterSubscribeHubId];
        await workerService.postWorker({
            hubId,
            distributorId,
            ...payload,
        });
        return {
            isSuccess: true,
        };
    },
    /**
     * 라이더 관리 배달대행료 수수료 그룹 조회
     */
    async getWorkerDeliveryFeeGroupList({ commit, rootGetters }) {
        const hubId = rootGetters[hubSelectorGetterType.getterSubscribeOnlyHubId];
        const response = await hubService.getWorkerDeliveryFeeGroup({
            hubId,
        });
        commit('GET_WORKER_DELIVERY_FEE_GROUP_LIST', response.data);
    },
    /**
     * 라이더 관리 자동 차감 그룹 조회
     */
    async getWorkerCashAutoDeductGroupList({ commit, rootGetters }) {
        const hubId = rootGetters[hubSelectorGetterType.getterSubscribeOnlyHubId];
        const response = await hubService.getWorkerCashAutoDeductGroup({
            hubId,
        });
        commit('GET_WORKER_CASH_AUTO_DEDUCT_GROUP_LIST', response.data);
    },
    /**
     * 라이더 관리 배차취소 패널티 그룹 조회
     */
    async getWorkerAllocatedCancelPenaltyGroupList({ commit, rootGetters }) {
        const hubId = rootGetters[hubSelectorGetterType.getterSubscribeOnlyHubId];
        const response = await hubService.getWorkerAllocatedCancelPenaltyGroup({
            hubId,
        });
        commit('GET_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_LIST', response.data);
    },
    clearWorkerDeliveryFeeGroupList({ commit }) {
        commit('CLEAR_WORKER_DELIVERY_FEE_GROUP_LIST');
    },
    clearWorkerCashAutoDeductGroupList({ commit }) {
        commit('CLEAR_WORKER_CASH_AUTO_DEDUCT_GROUP_LIST');
    },
    clearWorkerAllocatedCancelPenaltyGroupList({ commit }) {
        commit('CLEAR_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_LIST');
    },
};
